import { useState, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2'
import Icon from '../../../../components/icon'
import apiUrl from '../../../../configs/constant'
import {
    Box,
    Grid,
    Typography,
    Divider,
    Fab,
    Button,
    FormControl,
    TextField,
    FormHelperText,
    Checkbox,
    FormControlLabel,
    Select,
    MenuItem,
    InputLabel,
    Paper,
    DialogActions
} from '@mui/material'
import MsiDatagridAutoPlain from '../../../../components/custom/MsiDatagridAutoPlain';
import { useToast } from '../../../../components/ToastProvider'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import { getValue } from '@testing-library/user-event/dist/utils'
interface FormInputs {
    syscabang_id: number
    mmbarang_divisi_id: number
    mmbarang_kelompok_id: number
    mmbarang_class_id: number
    mmjenis_barang_id: number
    kode: string
    mmsatuan_id: number
    mmgudang_id: number
    nama_barang: string
    qty_min: number
    is_kain: number
    is_stok: number
    is_batch: number
    is_jasa: number
    is_asset: number
    is_sales: number
    is_added_sales: number
    is_buy: number
    lebar_kain: number
    leadtime: number

    // harga barang
    harga_jual: any
    harga_perolehan: any
    harga_min: any
    tgl_berlaku: any
    keterangan_harga: any
    pengali_harga_jual: number
    pengali_harga_min: number
}

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const navigate = useNavigate()
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const { id } = useParams<{ id: string }>()
    const { showToast } = useToast();

    // State for select options
    const [divisiOptions, setDivisiOptions] = useState<any[]>([])
    const [kelompokOptions, setKelompokOptions] = useState<any[]>([])
    const [classOptions, setClassOptions] = useState<any[]>([])
    const [jenisOptions, setJenisOptions] = useState<any[]>([])
    const [satuanOptions, setSatuanOptions] = useState<any[]>([])
    const [gudangOptions, setGudangOptions] = useState<any[]>([])
    const [hargaBarang, setHargaBarang] = useState<any[]>([])
    const [loading, setLoading] = useState(true)
    const [openDialogHarga, setOpenDialogHarga] = useState(false)

    // Fetch select options
    useEffect(() => {
        fetchCombo('/mm/divisi-barang/list-combo', setDivisiOptions)
        fetchCombo('/mm/kelompok-barang/list-combo', setKelompokOptions)
        fetchCombo('/mm/kelas-barang/list-combo', setClassOptions)
        fetchCombo('/mm/jenis-barang/list-combo', setJenisOptions)
        fetchCombo('/mm/satuan/list-combo', setSatuanOptions)
        fetchCombo('/mm/gudang/list-combo', setGudangOptions)
    }, [])

    const fetchCombo = (endpoint: string, setter: (data: any[]) => void) => {
        axios
            .get(apiUrl.apiUrl + endpoint, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.success) setter(res.data.data)
            })
    }

    // Form setup
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>()

    // Fetch detail data for default values
    useEffect(() => {
        setLoading(true)
        axios
            .get(apiUrl.apiUrl + `/mm/barang/detail/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.success && res.data.data) {
                    const data = res.data.data
                    Object.keys(data).forEach(key => {
                        if (key in data) setValue(key as keyof FormInputs, data[key])
                    })
                    setValue('syscabang_id', cabang)
                    setValue('lebar_kain', data.lebar_kain || 0)
                    setValue('leadtime', data.leadtime || 0)
                }
            })
            .finally(() => setLoading(false))
    }, [id, token, setValue])

    // Fetch harga barang
    const fetchHargaBarang = () => {
        axios
            .get(apiUrl.apiUrl + `/mm/harga-barang/list/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.success) setHargaBarang(res.data.data)
            })
    }

    useEffect(() => {
        fetchHargaBarang()
    }, [id, token])
    useEffect(() => {

    }, [id, token])

    const onSubmit = (data: FormInputs) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/mm/barang/edit/' + id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/mm/master-barang')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    if (loading) return <Typography>Loading...</Typography>

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ padding: 20 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center', marginBottom: 2 }}>
                        Detail Master Barang
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            {/* Select fields */}
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel id='divisi-label'>Divisi</InputLabel>
                                    <Controller
                                        name='mmbarang_divisi_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <Select
                                                labelId='divisi-label'
                                                label='Divisi'
                                                {...field}
                                                error={Boolean(errors.mmbarang_divisi_id)}
                                            >
                                                {divisiOptions.map(opt => (
                                                    <MenuItem key={opt.id} value={opt.id}>{opt.nama}</MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.mmbarang_divisi_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel id='kelompok-label'>Kelompok</InputLabel>
                                    <Controller
                                        name='mmbarang_kelompok_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <Select
                                                labelId='kelompok-label'
                                                label='Kelompok'
                                                {...field}
                                                error={Boolean(errors.mmbarang_kelompok_id)}
                                            >
                                                {kelompokOptions.map(opt => (
                                                    <MenuItem key={opt.id} value={opt.id}>{opt.nama}</MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.mmbarang_kelompok_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel id='class-label'>Class</InputLabel>
                                    <Controller
                                        name='mmbarang_class_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <Select
                                                labelId='class-label'
                                                label='Class'
                                                {...field}
                                                error={Boolean(errors.mmbarang_class_id)}
                                            >
                                                {classOptions.map(opt => (
                                                    <MenuItem key={opt.id} value={opt.id}>{opt.nama}</MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.mmbarang_class_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel id='jenis-label'>Jenis Barang</InputLabel>
                                    <Controller
                                        name='mmjenis_barang_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <Select
                                                labelId='jenis-label'
                                                label='Jenis Barang'
                                                {...field}
                                                error={Boolean(errors.mmjenis_barang_id)}
                                            >
                                                {jenisOptions.map(opt => (
                                                    <MenuItem key={opt.id} value={opt.id}>{opt.nama}</MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.mmjenis_barang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <TextField
                                                label='Kode'
                                                {...field}
                                                error={Boolean(errors.kode)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.kode && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel id='satuan-label'>Satuan</InputLabel>
                                    <Controller
                                        name='mmsatuan_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <Select
                                                labelId='satuan-label'
                                                label='Satuan'
                                                {...field}
                                                error={Boolean(errors.mmsatuan_id)}
                                            >
                                                {satuanOptions.map(opt => (
                                                    <MenuItem key={opt.id} value={opt.id}>{opt.nama}</MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.mmsatuan_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel id='gudang-label'>Gudang</InputLabel>
                                    <Controller
                                        name='mmgudang_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field }) => (
                                            <Select
                                                labelId='gudang-label'
                                                label='Gudang'
                                                {...field}
                                                error={Boolean(errors.mmgudang_id)}
                                            >
                                                {gudangOptions.map(opt => (
                                                    <MenuItem key={opt.id} value={opt.id}>{opt.nama}</MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.mmgudang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama_barang'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <TextField
                                                label='Nama Barang'
                                                {...field}
                                                error={Boolean(errors.nama_barang)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama_barang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qty_min'
                                        control={control}
                                        rules={{ required: true, min: 0 }}
                                        render={({ field }) => (
                                            <TextField
                                                label='Qty Min'
                                                type='number'
                                                {...field}
                                                error={Boolean(errors.qty_min)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty_min && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='lebar_kain'
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                label='Lebar Kain'
                                                type='number'
                                                {...field}
                                                error={Boolean(errors.lebar_kain)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.lebar_kain && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='leadtime'
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                label='Lead Time'
                                                type='number'
                                                {...field}
                                                error={Boolean(errors.leadtime)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.leadtime && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {/* Checkbox fields */}
                            <Grid item xs={12} sm={12}>
                                <FormControlLabel
                                    control={
                                        <Controller
                                            name='is_kain'
                                            control={control}
                                            render={({ field }) => (
                                                <Checkbox
                                                    checked={field.value === 1}
                                                    onChange={e => field.onChange(e.target.checked ? 1 : 0)}
                                                />
                                            )}
                                        />
                                    }
                                    label='Is Kain'
                                />
                                <FormControlLabel
                                    control={
                                        <Controller
                                            name='is_stok'
                                            control={control}
                                            render={({ field }) => (
                                                <Checkbox
                                                    checked={field.value === 1}
                                                    onChange={e => field.onChange(e.target.checked ? 1 : 0)}
                                                />
                                            )}
                                        />
                                    }
                                    label='Is Stok'
                                />
                                <FormControlLabel
                                    control={
                                        <Controller
                                            name='is_batch'
                                            control={control}
                                            render={({ field }) => (
                                                <Checkbox
                                                    checked={field.value === 1}
                                                    onChange={e => field.onChange(e.target.checked ? 1 : 0)}
                                                />
                                            )}
                                        />
                                    }
                                    label='Is Batch'
                                />
                                <FormControlLabel
                                    control={
                                        <Controller
                                            name='is_jasa'
                                            control={control}
                                            render={({ field }) => (
                                                <Checkbox
                                                    checked={field.value === 1}
                                                    onChange={e => field.onChange(e.target.checked ? 1 : 0)}
                                                />
                                            )}
                                        />
                                    }
                                    label='Is Jasa'
                                />
                                <FormControlLabel
                                    control={
                                        <Controller
                                            name='is_asset'
                                            control={control}
                                            render={({ field }) => (
                                                <Checkbox
                                                    checked={field.value === 1}
                                                    onChange={e => field.onChange(e.target.checked ? 1 : 0)}
                                                />
                                            )}
                                        />
                                    }
                                    label='Is Asset'
                                />
                                <FormControlLabel
                                    control={
                                        <Controller
                                            name='is_sales'
                                            control={control}
                                            render={({ field }) => (
                                                <Checkbox
                                                    checked={field.value === 1}
                                                    onChange={e => field.onChange(e.target.checked ? 1 : 0)}
                                                />
                                            )}
                                        />
                                    }
                                    label='Is Sales'
                                />
                                <FormControlLabel
                                    control={
                                        <Controller
                                            name='is_added_sales'
                                            control={control}
                                            render={({ field }) => (
                                                <Checkbox
                                                    checked={field.value === 1}
                                                    onChange={e => field.onChange(e.target.checked ? 1 : 0)}
                                                />
                                            )}
                                        />
                                    }
                                    label='Is Added Sales'
                                />
                                <FormControlLabel
                                    control={
                                        <Controller
                                            name='is_buy'
                                            control={control}
                                            render={({ field }) => (
                                                <Checkbox
                                                    checked={field.value === 1}
                                                    onChange={e => field.onChange(e.target.checked ? 1 : 0)}
                                                />
                                            )}
                                        />
                                    }
                                    label='Is Buy'
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                                    <Button startIcon={<Icon icon='mdi:content-save' />} variant='contained' type='submit'>
                                        SIMPAN
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                    {/* Harga Barang Table */}
                    <Divider sx={{ my: 4 }} />
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                        <Typography variant='h6'>
                            Harga Barang
                        </Typography>
                        <Button
                            startIcon={<Icon icon='mdi:pencil' />}
                            variant='contained'
                            color='primary'
                            onClick={() => {
                                let url = apiUrl.apiUrl + "/mm/barang/detail-harga/" + id
                                axios.get(url, {
                                    params: {},
                                    headers: { Authorization: `Bearer ${token}` }
                                }).then((res) => {
                                    const harga = res.data.data
                                    const pengaliHargaMin = res.data.pengali_harga_min.nilai || 1;
                                    const pengaliHargaJual = res.data.pengali_harga_jual.nilai || 1;
                                    const today = new Date().toISOString().slice(0, 10);
                                    setValue('tgl_berlaku', today);
                                    setValue('pengali_harga_min', pengaliHargaMin);
                                    setValue('pengali_harga_jual', pengaliHargaJual);
                                    if (harga != null) {
                                        setValue('harga_min', Number(harga.harga_min))
                                        setValue('harga_jual', Number(harga.harga))
                                        setValue('harga_perolehan', Number(harga.harga_perolehan))
                                    }
                                    setOpenDialogHarga(true)
                                });

                            }}
                        >
                            Update Harga
                        </Button>
                    </Box>
                    <Paper>
                        <MsiDatagridAutoPlain key={1} array={hargaBarang} />
                    </Paper>
                </div>
            </Grid>

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogHarga}
                onClose={() => setOpenDialogHarga(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = apiUrl.apiUrl + '/mm/harga-barang/save-edit'
                    axios.post(url, {
                        mmbarang_id: id,
                        harga_perolehan: data.harga_perolehan,
                        harga_min: data.harga_min,
                        harga: data.harga_jual,
                        tgl: data.tgl_berlaku,
                        keterangan: data.keterangan_harga,
                        mmjenis_barang_id: data.mmjenis_barang_id
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setOpenDialogHarga(false);
                                fetchHargaBarang();
                            } else {
                                showToast(response.data.message, 'error');
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah/Update Harga Barang
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_berlaku'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='date'
                                                label='Tanggal Berlaku'
                                                value={value || ''}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.tgl_berlaku && (
                                    <FormHelperText error>Tanggal berlaku wajib diisi</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='harga_perolehan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='number'
                                                label='Harga Perolehan'
                                                value={value || ''}
                                                onChange={(e) => {
                                                    onChange(e);
                                                    const hargaPerolehan = parseFloat(e.target.value) || 0;
                                                    const pengaliMin = Number(getValues('pengali_harga_min')) || 0;
                                                    const pengaliJual = Number(getValues('pengali_harga_jual')) || 0;

                                                    setValue(
                                                        'harga_min',
                                                        hargaPerolehan + (hargaPerolehan * pengaliMin) / 100
                                                    );

                                                    setValue(
                                                        'harga_jual',
                                                        hargaPerolehan + (hargaPerolehan * pengaliJual) / 100
                                                    );
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.harga_perolehan && (
                                    <FormHelperText error>Harga perolehan wajib diisi</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='harga_min'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='number'
                                                label='Harga Min'
                                                value={value || ''}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.harga_min && (
                                    <FormHelperText error>Harga min wajib diisi</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='harga_jual'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='number'
                                                label='Harga Jual'
                                                value={value || ''}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.harga_jual && (
                                    <FormHelperText error>Harga jual wajib diisi</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan_harga'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value || ''}
                                                label='Keterangan'
                                                multiline
                                                rows={3}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogHarga(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid>
    )
}